import { useEffect, useRef, useState } from "react";
import { api, errText } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Progress } from "../../components/ui/progress";
import { toast } from "sonner";
import { PackagePlus } from "lucide-react";

// One-time import of the 50 starter ads; every ad goes to the Pending queue for approval.
export function SampleAdsImport() {
  const [s, setS] = useState(null);
  const timer = useRef(null);
  const load = () => api.get("/admin/sample-ads/status").then((r) => {
    setS(r.data);
    clearTimeout(timer.current);
    if (r.data.status === "running") timer.current = setTimeout(load, 2000);
  }).catch(() => {});
  useEffect(() => { load(); return () => clearTimeout(timer.current); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (!s) return null;
  const start = () => {
    if (!window.confirm(`Add ${s.total - s.already_imported} starter ads, each with its own new seller profile? They will wait in Pending until you approve them.`)) return;
    api.post("/admin/sample-ads/import").then(() => { toast.success("Import started"); setS({ ...s, status: "running", done: 0 }); setTimeout(load, 1500); })
      .catch((e) => toast.error(errText(e)));
  };
  const running = s.status === "running";
  const all = s.already_imported >= s.total;
  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-6 space-y-3 mb-6" data-testid="sample-ads-import">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h3 className="font-display text-lg font-bold text-[#12234A] flex items-center gap-2"><PackagePlus size={18} className="text-[#F5551E]" /> Starter ads</h3>
          <p className="text-sm text-slate-500 max-w-2xl">Adds {s.total} ready-made ads (10 dogs, 10 birds, 10 small pets, 10 reptiles, 5 wanted, 5 livestock), each from its own new seller profile with one photo. They all go to <b>Pending</b>, so nothing is public until an admin approves each one. Running it again never creates duplicates.</p>
        </div>
        <Button onClick={start} disabled={running || all} className="bg-[#F5551E] hover:bg-[#e04a15]" data-testid="sample-ads-import-btn">
          {running ? "Importing…" : all ? "All imported" : s.already_imported ? `Import remaining ${s.total - s.already_imported}` : `Import ${s.total} starter ads`}
        </Button>
      </div>
      {running && <Progress value={((s.done || 0) / s.total) * 100} className="h-2" />}
      <p className="text-xs text-slate-500" data-testid="sample-ads-status">
        {running ? `Working… ${s.done || 0} of ${s.total}` : s.status === "error" ? `Stopped with an error: ${s.error}` : `${s.already_imported} of ${s.total} imported${s.status === "done" ? " · approve them in the Pending tab" : ""}`}
      </p>
    </div>
  );
}
